
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/genre/[[...pathParams]]",
      function () {
        return require("private-next-pages/landing/genre/[[...pathParams]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/genre/[[...pathParams]]"])
      });
    }
  